import getDataFromCanvas from './getDataFromCanvas';

/**
 * VideoHelper
 */
export default class VideoHelper {

    constructor(options, cb) {

        this.cb = cb;
        this.map = options.url.split('/').pop();
        this.url = options.url;
        this.step = options.step;
        this.width = options.width;
        this.height = options.height;
        this.depth = options.depth;
        this.colorset = options.color;
        this.random = options.random;
        this.poster = options.poster;
        
        if(!this.url) throw new Error('Videohelper needs a video url');
        if(!this.poster) throw new Error('Videohelper needs a poster image');

        
        this.drawn = false;
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
        this.canvas.width = 640;
        this.canvas.height = 480;
        
        //debug
        //this.canvas.classList.add('canvas-debug');
        //document.body.appendChild(this.canvas);

        this.loadMedia();
    }

    play = () => {
        this.video.play();
    }

    pause = () => {
        this.video.pause();
    }

    loadMedia = () => {

        //preload poster
        new Promise((resolve, reject) => {
            const img = document.createElement('img');
            img.src = this.poster;
            this.img = img;
            
            img.onload = () => {
                this.ctx.drawImage(img, 0, 0);
                resolve();
            }            
            img.onerror = () => {
                reject('Error loading Video Poster');
            }
        }).then(() => {
            if(this.cb) this.cb();
        });

        //preload video
        const video = document.createElement('video');
        const source = document.createElement('source');
        video.controls = true;
        video.loop = true;
        video.muted = true;
        video.playsinline = true;
        this.video = video;

        new Promise((resolve, reject) => {
            window.fetch(this.url)
                .then(function(res) {
                    if (!res.ok) reject('Error loading Video');
                    return res;
                })
                .then(res => res.blob())
                .then(res => {
                    source.setAttribute('src', URL.createObjectURL(res));
                    source.setAttribute('type', 'video/mp4');
                    video.appendChild(source);
                    video.addEventListener('canplaythrough', () => {
                        //console.log('canplaythrough');
                        resolve();
                    }, { once: true });
                })
        })

        /*Promise.all([p1, p2])
            .then(() => console.log('all loaded, what now?'));*/
    }

    update = (options, cb) => {
        this.step = options.step;
        this.colorset = options.color;
        this.width = options.width;
        this.height = options.height;
        this.depth = options.depth;
        this.random = options.random;
        
        if(cb) cb();
    }


    readCanvas = () => {
        const { ctx, canvas, video } = this;
        ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        return getDataFromCanvas(canvas, this.step, this.width, this.height, this.depth, this.colorset, this.random);
    }
}